import styles from "./styles.module.css";

export function Separator({
  orientation = "horizontal",
  className = "",
  height = "",
}) {
  const separatorClass =
    orientation === "horizontal" ? styles.horizontal : styles.vertical;

  return (
    <div
      className={`${styles.separator} ${separatorClass} ${className}`}
      style={{ height: height }}
      role="separator"
      aria-orientation={orientation}
    />
  );
}
